import React, { ReactNode } from 'react'
import Modal from 'react-modal'
import styles from './modalFullScreenWTN.module.scss'
import { useModalState, useModalDispatch, BasicModalState } from 'hooks/use-modal'
import { ReactComponent as CloseIcon } from 'images/icons/icn_close.svg'
import classNames from 'classnames'

export interface ModalFullScreenWtnProps extends Omit<Modal.Props, 'isOpen'> {
  children: ReactNode
  textHeader: string
  widgetElId: string
  modalId: string
  classContent?: string
}

const ModalFullScreenWTN = ({
  children,
  textHeader,
  widgetElId,
  modalId,
  classContent,
  ...props
}: ModalFullScreenWtnProps) => {
  const modalState: BasicModalState = useModalState(modalId as never)
  const { modalDispatch, modalActions } = useModalDispatch(modalId as never)
  return (
    <Modal
      {...props}
      isOpen={modalState?.isOpen}
      onRequestClose={() => modalDispatch(modalActions.closeModal())}
      closeTimeoutMS={500}
      className={styles.modalWrapper}
      portalClassName='modal-fs-wtn-portal'
      appElement={document.getElementById(widgetElId) as HTMLElement}
    >
      <header className={styles.header}>
        <h2 className={styles.title}>{textHeader}</h2>
        <button
          onClick={() => modalDispatch(modalActions.closeModal())}
          className={styles.closeBtn}
          aria-label='close modal'
        >
          <CloseIcon aria-hidden />
        </button>
      </header>

      <div className={classNames(styles.content, classContent)}>{children}</div>
    </Modal>
  )
}

export default ModalFullScreenWTN
